module.exports = __webpack_public_path__ + "media/images/plans/photo_chapel/hall-list/plan-photowedding-lineup-kansai-4-9de60c20dfee3458e43ee82e1b24b261.png";